import { Skeleton } from '@/components/ui/skeleton';

/**
 * Loading placeholder for the split dot plot. Mirrors the real layout — a
 * 2-column grid of per-category cards, each with a header (swatch + label +
 * stats) and a bordered grid stub (sticky user column + dot rows) — so the
 * page doesn't reflow when the report finishes computing.
 */
export function DotPlotSkeleton() {
  return (
    <div className="grid grid-cols-1 items-start gap-x-6 gap-y-6 xl:grid-cols-2">
      {Array.from({ length: 8 }).map((_, i) => (
        <CategoryGridSkeleton key={i} />
      ))}
    </div>
  );
}

function CategoryGridSkeleton() {
  return (
    <section className="space-y-2">
      <header className="flex items-center gap-2">
        <Skeleton className="h-2.5 w-2.5 rounded-full" />
        <Skeleton className="h-4 w-16" />
        <Skeleton className="h-3 w-28" />
      </header>
      <div className="overflow-hidden rounded-lg border border-border bg-card">
        <div className="border-b border-border px-3 py-2">
          <Skeleton className="h-3 w-10" />
        </div>
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className="flex items-center gap-3 px-3 py-1.5">
            <Skeleton className="h-6 w-6 shrink-0 rounded-full" />
            <Skeleton className="h-3 w-28 shrink-0" />
            <div className="flex flex-1 items-center gap-3 overflow-hidden pl-4">
              {Array.from({ length: 10 }).map((_, j) => (
                <Skeleton key={j} className="h-2 w-2 shrink-0 rounded-full opacity-60" />
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default DotPlotSkeleton;
